import React, { Component } from 'react';
import PropTypes from 'prop-types';
import onClickOutside from 'react-onclickoutside';
import ModalDialog from '../ModalDialog';
import { withLang } from '../../i18n';
import styles from './popUpMenu.module.css';
import sharedStyles from '../../styles/shared';

class PopUpMenu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      modalOpen: false,
      action: undefined,
      modalText: ''
    };

    this.toggle = this.toggle.bind(this);
    this.reset = this.reset.bind(this);
    this.onConfirm = this.onConfirm.bind(this);
  }

  handleClick(e, item) {
    if (item.confirmAction && !this.state.modalOpen) {
      this.setState({
        modalOpen: true,
        modalText: this.props.translate(`${item.text}Confirm`),
        action: () => item.action(e, this.props.hostId)
      });
    } else {
      item.action(e, this.props.hostId);
    }
  }

  // Used by onClickOutside
  handleClickOutside() {
    this.setState({
      isOpen: false
    });
  }

  onConfirm() {
    this.state.action();
    this.reset();
  }

  reset() {
    this.setState({
      modalOpen: false,
      action: undefined,
      modalText: '',
      isOpen: false
    });
  }

  toggle() {
    this.setState((prevState) => ({
      isOpen: !prevState.isOpen
    }));
  }

  render() {
    const menuItems = this.props.menuItems.map((item) => {
      const icon = item.icon ? (
        <span className={`${item.icon} icon-2x hy-icon-container ${styles.liIcon}`} />
      ) : '';
      return (
        <li key={item.text}>
          <button
            type="button"
            disabled={item.disabled}
            onClick={(e) => this.handleClick(e, item)}
            className={`${styles.menuItem} ${styles.button}`}
          >
            {icon}
            <span className={styles.itemText}>{item.text}</span>
          </button>
        </li>
      );
    });
    const titleRow = this.props.title ? (<h3 className={styles.header}>{this.props.title}</h3>) : '';

    const renderChildMenuButton = (child) => React.cloneElement(child, { onClick: this.toggle });

    return (
      <div className={`${this.props.className} ${styles.container}`}>

        {this.props.children
          ? renderChildMenuButton(this.props.children)
          : <DefaultMenuButton onClick={this.toggle} />}

        <div className={`${styles.list} ${this.state.isOpen ? '' : sharedStyles.hidden}`}>
          {titleRow}
          <ul>
            {menuItems}
          </ul>
        </div>
        <ModalDialog
          isOpen={this.state.modalOpen}
          onCancel={this.reset}
          onConfirm={this.onConfirm}
        >
          {this.state.modalText}
        </ModalDialog>
      </div>
    );
  }
}

const DefaultMenuButton = ({ onClick }) => {
  const DOWN_TRIANGLE = '▾';
  return (
    <button type="button" onClick={onClick} className={styles.button}>
      {DOWN_TRIANGLE}
    </button>
  );
};

const {
  func, arrayOf, shape, string, element, bool
} = PropTypes;

DefaultMenuButton.propTypes = {
  onClick: func.isRequired
};

PopUpMenu.propTypes = {
  translate: func.isRequired,
  hostId: string.isRequired,
  title: string,
  className: string,
  menuItems: arrayOf(shape({
    icon: string,
    action: func.isRequired,
    text: string.isRequired,
    disabled: bool
  })).isRequired,
  children: element
};

PopUpMenu.defaultProps = {
  title: '',
  className: '',
  children: null
};

export default withLang(onClickOutside(PopUpMenu));
